export const compareString = (a,b) => {
    if (a<b) return -1
    if (b>a) return 1
    return 0
}


// WEBPACK FOOTER //
// ./src/twd/compare.js